import { WifiOff } from 'lucide-react';

interface OfflineNoticeProps {
  isOnline: boolean;
}

/**
 * Component to display an offline notice when there's no internet connection
 * Shows a prominent banner at the top of the page when offline
 */
export function OfflineNotice({ isOnline }: OfflineNoticeProps): JSX.Element | null {
  if (isOnline) {
    return null;
  }

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[100] bg-red-600 text-white px-4 py-3 shadow-lg"
      role="alert"
      aria-live="assertive"
    >
      <div className="max-w-7xl mx-auto flex items-center gap-3">
        <WifiOff size={20} className="shrink-0" aria-hidden="true" />
        <div className="flex-1">
          <p className="font-semibold text-sm">No Internet Connection</p>
          <p className="text-xs text-red-100 mt-0.5">
            Please check your internet connection. Some features may not be available.
          </p>
        </div>
      </div>
    </div>
  );
}
